<template>
  <a-date-picker v-model:value="time" :second-step="60" :minute-step="5" show-time allow-clear />
</template>
<script setup lang="ts">
import dayjs from 'dayjs'
import { computed } from 'vue'

const props = defineProps<{
  value?: string
}>()

const emits = defineEmits(['update:value'])

const time = computed({
  get() {
    return dayjs(props.value)
  },
  set(val) {
    emits('update:value', val.format('YYYY-MM-DD HH:mm:ss'))
  }
})

</script>